<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" :aria-labelledby="ariaLabelledby" aria-hidden="true" @click="onModalClick" @keydown="onKeyDown">
    <div :class="'modal-dialog modal-dialog-centered ' + classes " role="document">
      <div class="modal-content">
        <div class="modal-header px-0 pt-0">
          <span v-if="updateFunction !== undefined" class="updateButton">
            <img v-if="updateStatus" src="../../../assets/loaderPrimary.svg" height="23" alt="">
            <a v-else href="#" @click="updateFunction()">
              <v-icon name="co-reload" style="cursor: pointer; color: #cc0b7a;" scale="1.2" :title="updateTitle" />
            </a>
          </span>
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onCloseX">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body pt-4 px-0 pb-0">
          <slot />
        </div>
        <!-- <div class="modal-footer" v-if="footer != false && footer != 'false'">
          <button type="button" class="btn generalSecondaryButton" data-dismiss="modal">Cerrar</button>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import { Modal as BootstrapModal } from "bootstrap";
export default {
  name: 'ContractFilters',
  props: [
    'id',
    'ariaLabelledby',
    'modalTitle',
    'class',
    'showFooter',
    'onClose',
    'updateFunction',
    'updateStatus',
    'updateTitle',
  ],
  data() {
    return {
      classes: this.class,
      footer: this.showFooter == undefined ? true : this.showFooter,
      modalInstance: null,
    };
  },
  mounted() {
    const modalElement = document.getElementById(this.id);
    if (modalElement) {
      this.modalInstance = new BootstrapModal(modalElement, {
        backdrop: "static",
        keyboard: false,
      });
    }
  },
  watch: {
    class() {
      this.classes = this.class;

    }

  },
  methods: {
    show() {
      if (this.modalInstance) {
        this.modalInstance.show();
      }
    },
    hide() {
      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    onCloseX() {
      if (typeof this.onClose === 'function') {
          this.onClose();
      }
		},
    onModalClick(event) {
      if (event.target === this.$el && typeof this.onClose === 'function') {
          this.onClose();
      }
		},
    onKeyDown(event) {
      if (event.keyCode === 27 && typeof this.onClose === 'function') {
        this.onClose();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-content {
  padding: 30px 30px 20px;
  max-height: 93vh;
  overflow-y: auto;
}
.close {
    font-size: 3rem;
    line-height: 0.4;
    font-weight: normal;
  }
.updateButton {
  margin-right: 5px;
  border: #cc0b7a 1px solid;
  border-radius: 0.25rem;
  padding: 2px;
  width: 29px;
  height: 29px;
}
</style>
